import {Component, Input, OnInit} from '@angular/core';
import {HelperService} from '../../../services/helper.service';
import {EmployeeService} from '../../../employee.service';
import {FirebaseStorageService} from '../../../services/firebase-storage.service';
import {finalize} from 'rxjs/operators';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {ExternalStaffService} from '../../../services/external-staff.service';
import {LogbookService} from '../../../services/logbook.service';
import {AuthorizationService} from '../../../services/authorization.service';
import { StaffOutsideStationModuleComponent } from '../../../staff-outside-station/staff-outside-station-module/staff-outside-station-module.component';
import { OutsideStaffService } from '../../../services/outside-staff.service';
import * as moment from 'moment';
import { ModuleExternalStaffComponent } from '../../../external-staff/module-external-staff/module-external-staff.component';

@Component({
  selector: 'ngx-create-logbook-manteinence',
  templateUrl: './create-logbook-manteinence.component.html',
  styleUrls: ['./create-logbook-manteinence.component.scss'],
})
export class CreateLogbookManteinenceComponent implements OnInit {
  @Input() stationId: string;
  @Input() logbook: any;
  @Input() canEdit: boolean = true;

  constructor(
    private logbookService: LogbookService,
    private employeeService: EmployeeService,
    private externalStaffService: ExternalStaffService,
    private outsideStaffService: OutsideStaffService,
    private dialogService: NbDialogService,
    private firebaseStorageService: FirebaseStorageService,
    protected ref: NbDialogRef<CreateLogbookManteinenceComponent>,
    private authorizationService: AuthorizationService,
  ) { }
  loading: boolean = false;
  typeMaintenance = [
    {
      value: 'mantenimiento_preventivo',
      label: 'Mantenimiento Preventivo',
      checked: false
    },
    {
      value: 'mantenimiento_correctivo',
      label: 'Mantenimiento Correctivo',
      checked: false
    },
    {
      value: 'mantenimiento_predictivo',
      label: 'Mantenimiento Predictivo',
      checked: false
    }
  ]
  employees = [];
  images = [];
  uploads = [];
  uploadPercent: any;
  downloadURLs = [];
  externalStaff = [];
  authorizations = [];
  readyData = false;
  newDate = false;
  outsideStaff = [];
  paramsMtoGeneral = [
    {
      equip: 'Protección auditiva',
      detail: 'Tapones, diademas auditivas, orejeras',
      value: false,
    },
    {
      equip: 'Casco de seguridad',
      detail: 'Cascos de seguridad, cascos de protección con reflejante termoplástico y barbiquejo',
      value: false,
    },
    {
      equip: 'Protección para manos',
      detail: `Guantes de uso general: Algodón, Poliéster, Nylon libre de pelusa, guantes para altas temperaturas, guantes para soldar, guantes de uso pesado, guantes contra quimicos - acidos, solventes - causticos, aplicaciones en frio, guantes anticorte - manejo de vidrio, cuchillas, herramienta de corte, hojas de acero.`,
      value: false,
    },
    {
      equip: 'Protección ocular',
      detail: 'Lentes de seguridad',
      value: false,
    },
    {
      equip: 'Máscara de soldar',
      detail: 'Máscara de mano, máscara de cabeza, máscara fotosensible',
      value: false,
    },
    {
      equip: 'Arnés/Cinturón de seguridad',
      detail: 'Arneses para trabajo en alturas, ascenso y descenso, espacios confinados y suspendido',
      value: false,
    },
    {
      equip: 'Ropa protectora de trabajo',
      detail: `Overol contra choques eléctricos resistente al fuego, protección contra ambientes de alto calor, mandil de nopreno para salpicaduras de químicos. Camisolas de mezclilla, mandil, mangas de mezclilla, vinil, laminadas, overol de gabardina.`,
      value: false,
    },
    {
      equip: 'Otro',
      detail: '',
      value: false,
    },
  ];
  paramsMtoGeneralAltura = [
    {
      equip: 'Protección auditiva',
      detail: 'Tapones, diademas auditivas, orejeras',
      value: false,
    },
    {
      equip: 'Casco de seguridad',
      detail: 'Cascos de seguridad, cascos de protección con reflejante termoplástico y barbiquejo',
      value: false,
    },
    {
      equip: 'Protección para manos',
      detail: `Guantes de uso general: Algodón, Poliéster, Nylon libre de pelusa, guantes para altas temperaturas, guantes para soldar, guantes de uso pesado, guantes contra quimicos - acidos, solventes - causticos, aplicaciones en frio, guantes anticorte - manejo de vidrio, cuchillas, herramienta de corte, hojas de acero.`,
      value: false,
    },
    {
      equip: 'Protección ocular',
      detail: 'Lentes de seguridad',
      value: false,
    },
    {
      equip: 'Máscara de soldar',
      detail: 'Máscara de mano, máscara de cabeza, máscara fotosensible',
      value: false,
    },
    {
      equip: 'Arnés/Cinturón de seguridad',
      detail: 'Arneses para trabajo en alturas, ascenso y descenso, espacios confinados y suspendido',
      value: false,
    },
    {
      equip: 'Ropa protectora de trabajo',
      detail: `Overol contra choques eléctricos resistente al fuego, protección contra ambientes de alto calor, mandil de nopreno para salpicaduras de químicos. Camisolas de mezclilla, mandil, mangas de mezclilla, vinil, laminadas, overol de gabardina.`,
      value: false,
    },
    {
      equip: 'Otro',
      detail: ``,
      value: false,
    },
  ];

  async ngOnInit() {
    if (this.logbook.fields.typeMaintenance) for (const type of this.logbook.fields.typeMaintenance.split(',')) this.typeMaintenance.find(typeAux => typeAux.value === type).checked = true
    if (this.logbook.fields.dataTypeActivity.paramsMtoGeneralAltura && this.logbook.fields.dataTypeActivity.paramsMtoGeneralAltura) this.paramsMtoGeneralAltura = this.logbook.fields.dataTypeActivity.paramsMtoGeneralAltura;
    this.logbook.fields.typeActivity = this.logbook.fields.typeActivity ? this.logbook.fields.typeActivity : '';
    if ('date_realization' in this.logbook.fields) this.newDate = true;
    await Promise.all([
      this.getEmployees(),
      this.getExternalStaffStation(),
      this.getAuthorizations()
    ]);
    this.readyData = true;
  }

  dismiss() {
    this.ref.close();
  }

  openModalNewExternalStaff(isEdit: boolean = false) {
    this.dialogService.open(ModuleExternalStaffComponent, {
      hasScroll: true,
      context: {
        externalStaff: {
          name: '',
          rfc: '',
          address: '',
          phone: '',
        },
        stationId: this.stationId,
        isEdit,
      },
    }).onClose.subscribe((modified: boolean) => modified ? this.getExternalStaffStation() : console.error('no modificaron'));
  }

  async loadImage(event: any) {
    if (!event.target.files.length) return;
    for await (const image of event.target.files) {
      const reader = new FileReader();
      await reader.readAsDataURL(image);
      reader.onload = (e: any) => {
        image.imageBase64 = e.target.result;
        this.images.push(image);
      };
    }
  }

  async getAuthorizations() {
    this.loading = true;
    const [err, response]: any = await this.authorizationService.index(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops,', 'error', 'Intenta más tarde [Error. Lista de Autorizaciones]');
    this.authorizations = response.data;
  }

  async getExternalStaffStation() {
    this.loading = true;
    const [err, response]: any = await this.externalStaffService.getExternalStaffStation(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista proveedores]', 'error');
    this.externalStaff = response.data;
  }

  async getEmployees () {
    this.loading = true;
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    this.employees = result.data;
  }

  formatedTypeMaintenance () {
    const response = []
    for (const type of this.typeMaintenance) if (type.checked) response.push(type.value)
    return response.join(',')
  }

  async store() {
    const validDataHasEmptyFields = Object.keys(this.logbook).includes('');
    const validFieldsHasEmptyFields = Object.keys(this.logbook.fields).includes('');
    if (validDataHasEmptyFields || validFieldsHasEmptyFields) return this.alert('Ingresa todos los datos necesiarios', 'error');
    this.loading = true;
    if (!this.newDate) delete this.logbook.fields.date_realization
    else {
      this.logbook.end_date = this.logbook.fields.date_realization
    }
    this.logbook.fields.typeMaintenance = this.formatedTypeMaintenance()
    if (this.logbook.fields.typeActivity === 'trabajo_mantenimiento_general') this.logbook.fields.dataTypeActivity.paramsMtoGeneral = this.paramsMtoGeneral;
    if (this.logbook.fields.typeActivity === 'trabajo_altura') this.logbook.fields.dataTypeActivity.paramsMtoGeneralAltura = this.paramsMtoGeneralAltura;
    console.log('🚀 ~ file: create-logbook-manteinence.component.ts:216 ~ CreateLogbookManteinenceComponent ~ store ~ this.logbook:', this.logbook)
    const [error, result] = await this.logbookService.store(this.stationId, this.logbook) as any;
    if (error) {
      const errorMessage = '<p>' + error.error.error.join('<br>') + '</p>';
      this.loading = false;
      return this.alert('Oops, ocurrió algo', 'error', '', errorMessage);
    }
    const logbookId = result.data.id;
    if (!this.images.length) {
      this.loading = false;
      await this.alert('Bitácora creada con éxito', 'success');
      return this.ref.close(true);

    }
    await this.firebaseStorageService.setPath('images/logbooks');
    this.uploads = [];
    this.downloadURLs = [];
    for await (const [index, file] of this.images.entries()){
      const filename = `${logbookId}_${index}`;
      const fileRef = await this.firebaseStorageService.referenceCloudStorage(filename);
      const task = this.firebaseStorageService.taskCloudStorage(filename, file);
      // get notified when the download URL is available
      task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(async (url) => {
            this.downloadURLs = this.downloadURLs.concat([url]);
            if (this.images.length === this.downloadURLs.length) {
              const firstURL = this.downloadURLs[0];
              this.downloadURLs.shift();
              const [err] = await this.logbookService.updateUrlImage(logbookId, firstURL, this.downloadURLs);
              if (err) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
              await this.alert('Bitácora creada con éxito', 'success');
              this.loading = false;
              this.ref.close(true);
            }
          });
        }),
      ).subscribe();
    }
  }

  async delete(index: number) {
    this.images.splice(index, 1);
  }

  async validateExternalStaff() {
    this.logbook.external_staff = {};
    if (this.logbook.responsable !== 'otro') return;
  }

  async changeTypeActivity() {
    this.logbook.fields.dataTypeActivity = {};
    if (this.logbook.fields.typeActivity === 'trabajo_altura') {
      this.logbook.fields.dataTypeActivity = { placeWork: '', levelDangerous: '', typeWork: '', outsideStaff: [], authorized_person: '' };
    }
    if (this.logbook.fields.typeActivity === 'trabajo_caliente') {
      this.logbook.fields.dataTypeActivity = { levelDangerous: '', typeWork: '', outsideStaff: [], authorized_person: '' };
    }
    if (this.logbook.fields.typeActivity === 'trabajo_mantenimiento_general') {
      this.logbook.fields.dataTypeActivity = { outsideStaff: [], authorized_person: '' };
    }

    if (this.logbook.fields.typeActivity !== '') this.getOutsideStaff();
  }

  openModalOutsideStaff(isEdit = false) {
    this.dialogService.open(StaffOutsideStationModuleComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        isEdit,
      },
    }).onClose.subscribe((modified: boolean) => modified ? this.getOutsideStaff() : console.error('no modificaron nada'));
  }

  async getOutsideStaff() {
    this.loading = true;
    const [err, response]: any = await this.outsideStaffService.index(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Error. Lista personal externo');
    this.outsideStaff = response.data;
  }

  async alert(title: string = 'asdasd', icon: SweetAlertIcon = 'success', text: string = '', html: string = '') {
    await Swal.fire({ icon, title, text, html });
  }

}
